import script from "./DropDownTranspose.vue?vue&type=script&setup=true&lang=js"
export * from "./DropDownTranspose.vue?vue&type=script&setup=true&lang=js"

import "./DropDownTranspose.vue?vue&type=style&index=0&id=d4ff6abc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4ff6abc"]])

export default __exports__